import { gql } from '@apollo/client/core'
import { RESOURCE_FRAGMENT } from '../fragments/Resource'

export const LIST_RESOURCES_QUERY = gql`
  ${RESOURCE_FRAGMENT}

  query listResources(
    $tagIds: [String!]
    $sortOrder: SortOrder!
    $sortField: ResourceSortField!
    $limit: Int!
    $offset: Int!
  ) {
    listResources(
      filter: { tagIds: $tagIds }
      sort: [{ sortField: $sortField, sortOrder: $sortOrder }]
      limit: $limit
      offset: $offset
    ) {
      ... on ListResourcesOutput {
        resources {
          ...Resource
        }
        count
      }
    }
  }
`
